import DOMPurify from 'dompurify';

class StringExtension extends String {
  private $this: string;

  constructor(t: string) {
    super(t);
    this.$this = t;
  }

  sanitize() {
    return DOMPurify.sanitize(this.$this);
  }
}

export const getParameterFromURLHash = (
  searchKey: string
): string | undefined => {
  try {
    const { hash } = window.location;
    if (!hash || !hash.startsWith('#')) {
      return undefined;
    }

    const queryStart = hash.indexOf('?');
    if (queryStart === -1) {
      return undefined;
    }

    const queryString = hash.slice(queryStart + 1);
    const params = new URLSearchParams(queryString);
    const value = params.get(searchKey);

    const sanitisedValue = value
      ? new StringExtension(value).sanitize()
      : undefined;

    return sanitisedValue;
  } catch (error) {
    console.error('Error extracting parameter from URL:', error?.message);
    return undefined;
  }
};

export default StringExtension;
